export const PATHS = {
  // Analytics base path
  ANALYTICS: "/analytics",
  // Manage Skills Extraction paths
  MANAGE: "/analytics/manage",
  PRIMARY_TEXT_PATH: "/analytics/manage/primary-text",
  SECONDARY_TEXT_PATH: "/analytics/manage/secondary-text",
  NEGATIVE_TEXT_PATH: "/analytics/manage/negative-text",
  PRIMARY_TEXT_PATH_ADD: "/analytics/manage/primary-text/add",
  SECONDARY_TEXT_PATH_ADD: "/analytics/manage/secondary-text/add",
  NEGATIVE_TEXT_PATH_ADD: "/analytics/manage/negative-text/add",
  // Benchmark paths
  BENCHMARK: "/analytics/benchmark",
  BENCHMARK_SKILLS_PATH: "/analytics/benchmark/skills",
  BENCHMARK_MICROSKILLS_PATH: "/analytics/benchmark/microskills",
  BENCHMARK_JFA_PATH: "/analytics/benchmark/jfa",
  BENCHMARK_SKILLS_PATH_ADD: "/analytics/benchmark/skills/add",
  BENCHMARK_MICROSKILLS_PATH_ADD: "/analytics/benchmark/microskills/add",
  BENCHMARK_JFA_PATH_ADD: "/analytics/benchmark/jfa/add",
};

export default PATHS;